import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import Typography from "@material-ui/core/Typography";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Paper from "@material-ui/core/Paper";
import AutoComplete from "./AutoComplete";
import { getFactorCompany } from "../../modules/factorCompany";
import formatLocation from "../../helpers/format/formatAddress";
import API from "../../api";

const DetailsFactorCompany = ({ value }) => {
  if (!value) return <div />;
  return <Typography variant="caption">{value}</Typography>;
};

const ConnectedBrokerAutoComplete = ({
  onNoOptionClick,
  paymentProfileId,
  ...props
}) => {
  const loadOptions = useCallback(async (company_name, paymentProfileId) => {
    const res = await API.groups.getPaymentProfileRelationships(
      paymentProfileId,
      20,
      "-created",
      { company_name }
    );
    if (!isEmpty(res.results)) {
      return map(res.results, object => ({
        label: object.factoring.company_profile.name,
        ...object
      }));
    }
    return [];
  }, []);

  const Option = ({
    innerRef,
    isFocused,
    isSelected,
    innerProps,
    children,
    data,
    ...props
  }) => (
    <ListItem dense divider selected={isFocused} button buttonRef={innerRef}>
      <ListItemText
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400
        }}
        {...innerProps}
        primary={data.name}
        secondary={
          <React.Fragment>
            <Typography component="span" color="textSecondary">
              {data.factoring.company_profile.name}
            </Typography>
            {data.factoring.company_profile.mc &&
              `MC: ${data.factoring.company_profile.mc}`}
            {data.factoring.company_profile.dot &&
              `DOT: ${data.factoring.company_profile.dot}`}
          </React.Fragment>
        }
      />
    </ListItem>
  );

  const Menu = ({ selectProps, innerProps, children }) => (
    <Paper square className={selectProps.classes.paper} {...innerProps}>
      <List dense="dense">{children}</List>
    </Paper>
  );

  return (
    <AutoComplete
      loadOptions={name => loadOptions(name, paymentProfileId)}
      autoCompleteComponents={{ Option, Menu }}
      {...props}
    />
  );
};
export default ConnectedBrokerAutoComplete;
